import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatestWith} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import {ManagementStoreService} from './management-store.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {genericSort} from '@emm/core/util/sort.util';
import {GenericItem} from '@emm/core/models/context-menu-action.model';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

@Injectable({
    providedIn: 'root'
})
export class ConsumerTypesFacadeService {

    consumerTypes$ = this.api.getConsumerTypes();
    selectedConsumerType$ = new BehaviorSubject<any>(null);

    consumerTypesAsGenericItems$ = this.consumerTypes$.pipe(
        filter(RA.isNotNil),
        map((consumerTypes) =>
            consumerTypes.sort(genericSort(a => a['name']))
                .map(
                    (consumerType) =>
                        ({
                            name: consumerType.name,
                            tag: consumerType.tag,
                            disabled: false,
                            source: consumerType
                        } as GenericItem<ConsumerType>)
                )
        )
    );

    centerLoading$ = this.managementStore.isLoading$.consumerTypes;
    rightLoading$ = this.managementStore.isLoading$.base;

    anyLoading$ = this.centerLoading$.pipe(
        combineLatestWith(this.rightLoading$),
        map((sources: boolean[]) => R.any(R.equals(true), sources))
    );

    constructor(private managementStore: ManagementStoreService,
                protected api: ManagementApiService) {
    }


    init(): void {
        this.managementStore.dispatch.initConsumerTypes();
    }


    selectConsumerType(consumerType: ConsumerType): void {
        this.selectedConsumerType$.next(consumerType);
    }


    searchItems(searchFilter: SearchFilter): void {
        this.managementStore.dispatch.searchConsumerTypes(searchFilter);
    }


    openAddDialog(): void {
        this.managementStore.dispatch.openAddConsumerTypeDialog();
    }

    startProgressBar(): void {
        this.managementStore.dispatch.startLoading();

    }
    stopProgressBar(): void {
        this.managementStore.dispatch.stopLoading();
    }
}
